import React from "react";
import { mapDots, count } from "../../../core/data/auditsPage";
import { formatDate } from "../../../core/data/marketOverviewText";
import { INDUSTRY } from "../../../core/theme/auditsTheme";
import ukOutline from "../../../assets/uk-outline.svg";

// The UK coverage map: one dot per postcode district searched in this
// industry, placed by mapPosition (core/data/auditsPage.js). Until repeat
// searches exist every dot is the same soft violet ("Searched so far").
// Districts outside the map (e.g. Shetland) still count; a line says how many.
//   niche: the roll-up's entry, or null    message: shown instead of the map
export default function CoverageMap({ niche, message }) {
  const { dots, offMap } = niche ? mapDots(niche.locationsCovered, niche.locations) : { dots: [], offMap: 0 };

  return (
    <div className={INDUSTRY.coverage}>
      <h2 className={INDUSTRY.label}>Coverage</h2>
      {message ? (
        <p className={INDUSTRY.note}>{message}</p>
      ) : (
        <>
          <div className={INDUSTRY.mapRow}>
            <div className={INDUSTRY.map}>
              <img src={ukOutline} alt="Map of the UK showing where data has been gathered" className={INDUSTRY.mapImg} />
              {dots.map(d => (
                <span
                  key={d.district} className={INDUSTRY.dot} style={{ left: `${d.x}%`, top: `${d.y}%` }}
                  title={`${d.district} · last searched ${formatDate(d.lastSearchedAt)}`}
                />
              ))}
            </div>
            <span className={INDUSTRY.legend}><span aria-hidden="true" className={INDUSTRY.legendDot} />Searched so far</span>
          </div>
          {offMap > 0 && <p className={INDUSTRY.note}>{count(offMap, "location isn't", "locations aren't")} on the map.</p>}
        </>
      )}
    </div>
  );
}
